<template>
    <a-space class="mb-2">
        <a-button type="primary" @click="addnews">
            <template #icon>
                <PlusOutlined />
            </template>
            新增事件
        </a-button>
        <a-button type="link" @click="getData">刷新数据</a-button>
    </a-space>
    <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
        :pagination="{
            current: page,
            pageSize: limit,
            total: count,
            showQuickJumper: true,
            showSizeChanger: true,
        }" @change="(pagination) => {
            page = pagination.current;
            limit = pagination.pageSize;
        }">
        <template #bodyCell="{ index, record, column }">
            <template v-if="column.dataIndex === 'index'">
                {{ index + 1 }}
            </template>
            <template v-if="column.dataIndex === 'operation'">
                <a-space>
                    <a href="javascript:;" @click="editPlan(record)">编辑</a>
                    <a-popconfirm title="确认删除？" placement="bottom" @confirm="removenews(record._id)">
                        <a href="javascript:;" style="color: red;">删除</a>
                    </a-popconfirm>
                </a-space>
            </template>
        </template>
    </a-table>
    <a-modal v-model:visible="newsModal" @ok="savenews" @cancel="cancelSave" ok-text="确认" cancel-text="取消"
        :confirm-loading="saving" :cancel-button-props="{ disabled: saving }" :maskClosable="false" :closable="!saving">
        <template #title>
            <a-space>
                <span>{{ newsForm._id === '' ? '编辑' : '' }}事件</span>
            </a-space>
        </template>
        <a-form ref="newsFormRef" name="newsForm" :model="newsForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"
            autocomplete="off">
            <a-row :gutter="16">
                <a-col :span="24">
                    <a-form-item label="标题" name="title" :rules="[{ required: true, message: '请输入标题' }]">
                        <a-input v-model:value="newsForm.title" placeholder="标题" :disabled="saving">
                        </a-input>
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="内容" name="content" :rules="[{ required: true, message: '请输入内容' }]">
                        <a-textarea v-model:value="newsForm.content" placeholder="内容"
                            :auto-size="{ minRows: 5, maxRows: 8 }" :disabled="saving">
                        </a-textarea>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
    </a-modal>
</template>
<script setup>
import { message } from "ant-design-vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";

const { proxy } = getCurrentInstance();
const newsFormRef = ref();

const dataLoading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const newsForm = ref({});
const newsModal = ref(false);
const saving = ref(false);

const columns = computed(() => {
    return [
        { title: '序号', dataIndex: 'index', width: 80 },
        { title: '标题', dataIndex: 'name', width: 150 },
        { title: '内容', dataIndex: 'content', width: 260 },
        { title: '创建时间', dataIndex: 'create_time', width: 150, },
        { title: '操作', dataIndex: 'operation', width: 100, fixed: 'right' }]
});
const width = computed(() => proxy.$utils.twidth(columns.value));

watch(() => page.value, () => {
    getData();
});
watch(() => limit.value, () => {
    if (page.value !== 1) page.value = 1;
    else getData();
});

onMounted(() => {
    getData();
});

const getData = () => {
    dataLoading.value = true;
    proxy.$api.doAPI("/news/list", { page: page.value, limit: limit.value }).then((res) => {
        dataLoading.value = false;
        if (res.code === 0) {
            data.value = _.map(res.data.list, n => {
                return {
                    ...n,
                    create_time: proxy.$dateFormat(n.create_time, 'YYYY-MM-DD HH:mm'),
                }
            });
            length.value = res.data.length;
            count.value = res.data.count;
            if (length.value > 0 && page.value > length.value) page.value = 1;
        } else {
            message.error(res.msg);
        }
    }).catch((err) => {
        dataLoading.value = false;
        console.error(err);
    });
};
const initForm = () => {
    return {
        _id: "",
        title: "",
        content: "",
    };
};
const addnews = () => {
    newsForm.value = initForm();
    newsModal.value = true;
};
const editnews = (item) => {
    newsForm.value = _.extend(initForm(), _.pick(item, _.keys(initForm())));
    newsModal.value = true;
}
const savenews = async () => {
    try {
        await newsFormRef.value.validateFields();
        saving.value = true;
        proxy.$api.doAPI("/news/save", { dataForm: newsForm.value }).then((res) => {
            saving.value = false;
            if (res.code === 0) {
                newsModal.value = false;
                message.success("保存成功");
                getData();
            } else {
                message.error(res.msg);
            }
        }).catch((err) => {
            saving.value = false;
            console.error(err);
        });
    } catch (errorInfo) {
        console.log("Failed:", errorInfo);
    }
};
const cancelSave = () => {
    newsFormRef.value.clearValidate();
    newsModal.value = false;
};
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
    display: flex;
    padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
    padding: 8px 8px !important;
}

p {
    margin: 0;
    padding: 0;
}
</style>